<template>
    <div>
        <van-uploader
            v-model="fileList"
            :before-read="beforeRead"
            :max-size="maxSize"
            :max-count="maxCount"
            :deletable="deletable"
            :disabled="disabled"
            @oversize="oversize"
            @delete="deleteFile"
            :multiple="multiple"
        />
    </div>
</template>
<script>
import { getFileToken, getPrivateUrl } from '@/api/upload.js';
import { request } from '@/utils/request';
import { randomString, imgUploadUrl } from '@/utils/upload.js';
// import dayjs from 'dayjs';
export default {
    name: "upload-img",
    props: {
        value: {
            require: true,
            default: () => [],
        },
        maxCount: {
            type: Number,
            default: 1
        },
        maxSize: {
            type: Number,
            default: 10 * 1000 * 1024
        },
        grade: {
            type: String,
            default: '1'
        },
        deletable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isArray: {
            type: Boolean,
            default: true
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fileList: [],
        }
    },
    watch: {
        value: {
            handler(val){
                if(this.isArray){
                    if(val.length !== this.fileList.length){
                        this.arrangeParams(val);
                    }
                } else {
                    this.arrangeParams(val);
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        oversize(){
            this.$emit("oversize");
        },
        beforeRead(file) {
            return new Promise((resolve, reject) => {
                if (!['image/png','image/jpeg'].includes(file.type)) {
                    let msg = '请上传 png 或 jpg 格式图片'
                    this.$toast(msg);
                    reject(msg)
                } else {
                    const params = {
                        pf: this.grade
                    }
                    getFileToken(params).then(res => {
                        const list = file?.name.split('.');
                        const suffix = list[list.length-1];
                        // 拼接后的图片名称+后缀
                        const key = `${randomString()}.${suffix}`;
                        const { token, domain } = res.data;
                        let data = new FormData();
                        data.append('token', token);
                        data.append('key', key);
                        data.append('file', file);
                        // 上传到七牛云地址
                        request({
                            url: imgUploadUrl,
                            method: 'POST',
                            data: data,
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then(async (response) => {
                            const url = `${domain}${response.key}`;
                            if(this.grade === '2'){
                                const newUrl = await this.getImgPath(url);
                                // const time = dayjs().add(2, 'minute');
                                if (this.multiple) {
                                    this.fileList = [
                                        ...this.fileList,
                                        {
                                        url: newUrl, // 私密的地址
                                        originUrl: url, // 原地址
                                        // time, // 过期时间（超过要重新请求获取私密的地址，默认2分钟过期）
                                        isImage: true
                                    }];
                                } else {
                                    this.fileList = [{
                                        url: newUrl, // 私密的地址
                                        originUrl: url, // 原地址
                                        // time, // 过期时间（超过要重新请求获取私密的地址，默认2分钟过期）
                                        isImage: true
                                    }];
                                }
                            } else {
                                if (this.multiple) {
                                    this.fileList = [
                                        ...this.fileList,
                                        {
                                        url,
                                        isImage: true
                                    }];
                                } else {
                                    this.fileList = [{
                                        url,
                                        isImage: true
                                    }];
                                }
                            }
                            this.emitValue();
                            resolve(response);
                        })
                    }).catch((error) => {
                        console.log(error)
                        reject(error)
                    })
                }
            })
        },
        // 如果是私密空间，需要整理参数
        async arrangeParams(val) {
            if(this.isArray){
                const res = val.map( async (i) => {
                    const { url } = i;
                    if(url){
                        if(url.includes('?e=')){
                            return url;
                        } else {
                            return await this.getImgPath(url);
                        }
                    } else {
                        return '';
                    }
                })
                const resList = await Promise.all(res);
                this.fileList = resList.map((item,index) => {
                    // const time = dayjs().add(2, 'minute');
                    return {
                        url: item,
                        originUrl: val[index].url,
                        // time
                    }
                })
            } else {
                const newUrl = await this.getImgPath(val);
                this.fileList = [{
                    url: newUrl,
                    originUrl: val,
                }]
            }
        },
        // 如果是私密空间，重新获取地址
        async getImgPath(url) {
            if(!url) return;
            let newUrl = url;
            // grade  1公共 2私密
            if(newUrl && this.grade === '2'){
                const params = {
                    url: url,
                    pf: this.grade
                }
                const res = await getPrivateUrl(params);
                if(res.data){
                    newUrl = res.data;
                }
            }
            return newUrl;
        },
        deleteFile(){
            this.emitValue();
        },
        emitValue(){
            const isGrade = this.grade === '2';
            const newFileList = this.fileList.map(i => {
                return {
                    url: isGrade ? i.originUrl : url
                }
            })
            this.$emit('input', newFileList);
        }
    }
}
</script>
<style lang="scss" scoped>
</style>